/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProspectFacilityRequest
 */
export interface UpdateProspectFacilityRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProspectFacilityRequest
     */
    facility_id: string;
}

/**
 * Check if a given object implements the UpdateProspectFacilityRequest interface.
 */
export function instanceOfUpdateProspectFacilityRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "facility_id" in value;

    return isInstance;
}

export function UpdateProspectFacilityRequestFromJSON(json: any): UpdateProspectFacilityRequest {
    return UpdateProspectFacilityRequestFromJSONTyped(json, false);
}

export function UpdateProspectFacilityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProspectFacilityRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
    };
}

export function UpdateProspectFacilityRequestToJSON(value?: UpdateProspectFacilityRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facility_id': value.facility_id,
    };
}

